import { useUserStore } from '@/shared/stores';
import { useCallback } from 'react';

/**
 * Hook Facade para interactuar con el store de usuarios.
 * Este es el ÚNICO lugar que debe importar y usar `useUserStore` directamente.
 * Proporciona una API estable y segura para el resto de la aplicación.
 */
export const useAppUser = () => {
  const apiData = useUserStore((state) => state.apiData);
  const searchQuery = useUserStore((state) => state.searchQuery);
  const isLoading = useUserStore((state) => state.isLoading);

  const loadData = useUserStore((state) => state.loadData);
  const setSearchQuery = useUserStore((state) => state.setSearchQuery);
  const setLoading = useUserStore((state) => state.setLoading);
  const clearUsers = useUserStore((state) => state.clearUsers);

  const handleSetSearchQuery = useCallback(
    (query: string) => {
      setSearchQuery(query);
    },
    [setSearchQuery],
  );

  const handleSetLoading = useCallback(
    (loading: boolean) => {
      setLoading(loading);
    },
    [setLoading],
  );

  const handleClearUsers = useCallback(() => {
    clearUsers();
  }, [clearUsers]);

  return {
    apiData,
    searchQuery,
    isLoading,

    loadData,
    setSearchQuery: handleSetSearchQuery,
    setLoading: handleSetLoading,
    clearUsers: handleClearUsers,
  };
};
